import React, { useState, useContext, useEffect, useRef } from 'react'
import './Pairs.css'
import { useDrag, useDrop } from 'react-dnd'



const ParameterImage = ({ option, start, onDrop }) => {
console.log(option)
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'all',

        item:
        {
            ...option,
            startId: start
        }

        ,
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    }), [option])

    const ref = useRef(null);
    drag(ref);

    const handleDrag = (e) => {
        // console.log('Dragging element with id', option)
        e.stopPropagation()
    }


    return (
        <img
            onDrag={(e) => handleDrag(e)}
            ref={ref}
            style={{
                zIndex: 1,
                cursor: 'grab',
                // margin: '-10px 0',

                // backgroundColor: isDragging ? 'pink' : '',
                opacity: isDragging ? .3 : '',
            }}
            className='pairs__answerImage' alt='' src={option.attachment_link}></img>
    )

}

export default ParameterImage